import { render, staticRenderFns } from "./ChangeSpecimenColorModal.vue?vue&type=template&id=2d4b1ae8"
import script from "./ChangeSpecimenColorModal.vue?vue&type=script&lang=js"
export * from "./ChangeSpecimenColorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports